import { Component, Input, OnInit, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { IImportItem, IImportErrorColumnRowModel } from '../../models';
import { ImportDateFormat, ImportInstanceDetailCode, ImportType } from '../../enums';
import { importColumnMapping, shouldHaveErrorsExpandedLines } from '../../functions';


@Component({
	selector: '[import-report-errors-list-table-row]',
	templateUrl: './import-report-errors-list-table-row.component.html',
	imports: [TranslateModule]
})
export class ImportReportErrorsListTableRowComponent implements OnInit {
	private translateService = inject(TranslateService);

	@Input() currentImport: IImportItem;
	@Input() reportErrorColumn: IImportErrorColumnRowModel;

	dateFormats = Object.entries(ImportDateFormat);

	columnName: string;
	errorMessage: { key: string, params?: any };

	ngOnInit() {
		this.columnName = 'Import.Creation.DataMapping.Columns.' + this.reportErrorColumn.column;
		this.errorMessage = this.buildErrorMessage(this.reportErrorColumn);
	}

	buildErrorMessage(data: IImportErrorColumnRowModel) {
		const codes = ImportInstanceDetailCode;
		const root = 'Import.Creation.ValidationAndProcessing.ReportErrorType';
		const config = this.currentImport.importFileConfiguration;
		let key = `${root}.${data.errorCode}`;
		let params: any = data;

		// date format error
		if (data.errorCode === codes.DateFormatTemplate) {
			const f = this.dataFormatTranslationsKeyFromValue(config.dateFormatTemplate);
			params = { format: this.translateService.instant(`Import.Configurations.DateFormats.${f}`) };
			return { key, params };
		}

		if ([ codes.DueDateMandatory, codes.AmountNegative ].includes(data.errorCode)) {
			if (this.currentImport.type === ImportType.Debtor) {
				key = `${root}.AmountNegativeGeneric`;
			} else {
				// Only for accounting like imports
				params = { firstExtraMessage: this.translateService.instant(`AccountingDocuments.Types.Full.${data.firstExtraMessage}`) };
			}
			return { key, params };
		}

		// default
		return {
			key: `${root}.${data.errorCode}`,
			params: data
		};
	}

	hasErrorReportLine = (row: IImportErrorColumnRowModel) => shouldHaveErrorsExpandedLines(row)

	dataFormatTranslationsKeyFromValue(value: string): string {
		return this.dateFormats.find(a => a[1].toLowerCase() === value.toLowerCase())[0];
	}

	columnMapping(column: string): string {
		return importColumnMapping(column, this.currentImport.columnsMapping);
	}
}
